function applyMask(value, cursor, mask) {
  let result = '';

  const ml = mask.length;
  const vl = value.length;

  // i - mask[i]; текущий символ в маске
  // j - value[j]; текущий символ в value

  for (let i = 0, j = 0; i < ml; i++) {
    const m = mask.charAt(i);
    let v = value.charAt(j);

    // при m == '1' берем текущее число из value
    // при m == '*' берем оставшиеся символы из value
    // иначе берем символ из маски если value не пустое (чтобы не пришлось удалять пробел при стирании символов)

    if (m === '1') {
      if (j++ < vl) {
        result += v;
      } else {
        break;
      }
    } else if (m === '*') {
      while (j < vl) {
        result += v;
        v = value.charAt(++j);
      }
    } else if (v !== '') {
      result += m;

      // если находимся до курсора, то передвигаем его
      if (i <= cursor) {
        // eslint-disable-next-line no-param-reassign
        cursor++;
      }
    }
  }

  return {
    value: result,
    cursor,
  };
}

// чистим символы по parseRegExp и переставляем курсор до текущей позиции курсора
function parse(value, cursor, parseRegExp) {
  let newCursor = cursor;

  const newValue = (value || '').replace(parseRegExp, (char, index) => {
    if (index < cursor) {
      newCursor -= 1;
    }

    return '';
  });

  return {
    value: newValue,
    cursor: newCursor,
  };
}

export default function applyPattern(current, cursor, parserRegExp, getPattern) {
  const { value: parsedValue, cursor: parsedCursor } = parse(current, cursor, parserRegExp);

  const mask = getPattern(parsedValue, current);

  return applyMask(parsedValue, parsedCursor, mask);
}
